<template>
  <div class="agreement bg-white">
    <p class="text-center f16 fb pad20-b">代付说明</p>
    <p>
      <span class="text-indent">本人/单位</span>【 {{ contInfo.contract1 }} 】（身份证号/统一社会信用代码：【{{ contInfo.contract2 }}】）
      不可撤销地同意就【 {{ contInfo.contract3 }} 】（身份证号/统一社会信用代码：【 {{ contInfo.contract4 }} 】）
      在农信商城（网址：nxinstore.com）上的发生的交易代其向卖家支付订单金额【 {{ contInfo.contract5 }} 】元。
    </p>
    <p>
      <span class="text-indent">对应交易单号：</span>【 {{ contInfo.contract6 }} 】。
    </p>
    <p>
      <span class="text-indent">卖家</span>【 {{ contInfo.contract7 }} 】（身份证/统一社会信用代码：【 {{ contInfo.contract8 }} 】）。
    </p>
    <p class="text-indent fb">本人/单位确认:</p>
    <p class="fb text-indent">
      （1）一经点击同意代付，将上述款项支付至卖家账户，即为完成代付，本人/单位将不得以任何理由撤销代付;
    </p>
    <p class="fb text-indent">
      （2）上述代付行为为本人/单位真实的意思表示，本人/单位已清楚知悉上述代付行为所代表的含义与法律责任，并自愿承担由此产生的一切责任;
    </p>
    <p class="fb text-indent">（3）因上述代付行为产生的任何纠纷，由本人/单位自行解决，与平台无关。</p>
    <p class="text-indent">
      本人/单位确认已知悉上述所有内容（特别是加粗字体内容）的意义以及由此产生的法律效力，自愿作出上述代付行为。
    </p>
    <p class="text-indent">
      本人/单位同意本代付说明文件使用杭州尚尚签网络科技有限公司提供的上上签电子签约平台服务通过电子签名以数据电文形式订立，具体出具数字证书的电子认证服务机构（CA,
      Certificate Authority）以实际签署时为准，一经本人/单位单方签署即发生法律效力；
    </p>
    <p class="text-indent">
      本人/单位同意在平台方及杭州尚尚签网络科技有限公司或其合作第三方的服务器上以电子形式保存本文件。本文件经本人/单位通过上述方式签署并于平台系统记录的签约之日起发生法律效力
    </p>
    <div v-if="hasCaAgreement" class="flex justify-center items-center agreement-check">
      <van-checkbox
        :value="agreementChecked"
        icon-size="15px"
        class="f12"
        @click.native.prevent="openCaAgreement"
      >
        我已阅读并同意<span class="blue" @click.stop="openCaAgreement">《{{ caAgreementName }}》</span>
      </van-checkbox>
    </div>
    <div class="text-center pad20-tb">
      <van-button round type="success" class="mar20-r" @click="toBack">返回</van-button>
      <van-button round type="danger" class="sign-submit-btn" :disabled="isSign" @click="sign">我已阅读并同意签署</van-button>
    </div>

    <van-popup
      v-model:show="authFilePopupShow"
      position="bottom"
      round
      :safe-area-inset-bottom="true"
      :close-on-click-overlay="false"
    >
      <div class="auth-file-popup pad20-tb pad30-lr">
        <div class="auth-file-popup__title fb f16">重要事项提醒</div>
        <div class="auth-file-popup__content f14 mar20-t gray3">
          <p class="mar10-b">1、请打印《企业授权书》并盖章，提供PDF或图片</p>
          <p>2、请保证授权书中<span class="red">被授权人与当前操作人保持一致</span>以免认证失败</p>
          <div class="auth-file-popup__link" @click="downloadAuthTemplate">点击下载《企业授权书》模版</div>
        </div>
        <div class="auth-file-popup__footer mar20-t text-center">
          <van-button round type="danger" @click="confirmAuthFileNavigate">已准备好</van-button>
          <div class="auth-file-popup__cancel blue text-center mar15-t" @click="authFilePopupShow = false">取消</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<style lang="scss" scoped>
@import "./index.scss";
</style>

<script>
import { Dialog, Toast } from "vant";
import requestApi from "@/utils/requestApi";

export default {
  data() {
    return {
      contractData: {},
      contInfo: {},
      orderId: "",
      pMoneyRecently: "",
      time: 5,
      msg: "",
      isSign: false,
      returnUrl: "",
      agreementChecked: false,
      hasCaAgreement: false,
      caAgreementUrl: "",
      caAgreementName: "上上签CA电子认证协议",
      isAuthFile: false,
      authFileTemplateUrl: "https://nfs.nxin.com/cxt/CA_Authorization2606.docx",
      authFilePopupShow: false,
      pendingNavigateUrl: "",
      isAuth: true,
      authMobUrl: "",
      authTips: ""
    };
  },
  created() {
    if (/(nxin.com)$/.test(window.location.host)) {
      document.domain = "nxin.com";
    }
    if (/(dbn.cn)$/.test(window.location.host)) {
      document.domain = "dbn.cn";
    }
    this.orderId = this.$route.query.orderId;
    this.getBasicCa();
    if (this.orderId === "" || this.orderId === "undefined") {
      this.isSign = true;
      return;
    }
    this.pMoneyRecently = this.$route.query.pMoneyRecently;
    this.returnUrl = this.$route.query.returnUrl ? decodeURIComponent(this.$route.query.returnUrl) : "";
    this.$store
      .dispatch("treaty/paymentOnBehalf/queryPaymentOnBehalfTreaty", {
        orderId: this.orderId,
        pMoneyRecently: this.pMoneyRecently
      })
      .then(data => {
        this.contractData = data.contractData;
        this.contInfo = JSON.parse(data.contractData.contInfo);
      });
  },
  methods: {
    getBasicCa() {
      if (!this.orderId || this.orderId === "undefined") {
        return;
      }
      requestApi
        .post("sctrading/contract/getBasicCa", {
          returnUrl: window.location.href,
          orderId: this.orderId,
          contractType: "invoiceDf"
        })
        .then(res => {
          const { code, data } = res;
          if (code == 0) {
            const { url, name, isAuthFile, templateUrl, authFileUrl, authMobUrl, isAuth, tips, isExpired } =
              data || {};
            if (isExpired === false && url) {
              window.location.href = url;
              return;
            }
            if (url) {
              this.caAgreementUrl = url;
              this.caAgreementName = name || "上上签CA电子认证协议";
              this.hasCaAgreement = true;
            }
            this.isAuthFile = !!isAuthFile;
            this.authFileTemplateUrl = templateUrl || authFileUrl || this.authFileTemplateUrl;
            if (typeof isAuth !== "undefined") {
              this.isAuth = isAuth;
            }
            this.authMobUrl = authMobUrl || "";
            this.authTips = tips || "";
          }
        });
    },
    goToCaUrl(url) {
      if (!url) {
        Toast("协议链接获取中，请稍后重试");
        return;
      }
      if (this.isAuthFile) {
        this.pendingNavigateUrl = url;
        this.authFilePopupShow = true;
        return;
      }
      window.location.href = url;
    },
    confirmAuthFileNavigate() {
      this.authFilePopupShow = false;
      if (this.pendingNavigateUrl) {
        window.location.href = this.pendingNavigateUrl;
      }
    },
    downloadAuthTemplate() {
      if (this.authFileTemplateUrl) {
        window.location.href = this.authFileTemplateUrl;
        return;
      }
      Toast("模版下载链接获取中，请稍后重试");
    },
    showAuthConfirm() {
      Dialog.confirm({
        message: this.authTips
      }).then(() => {
        this.navigateToAuthMobUrl();
      });
    },
    openCaAgreement() {
      if (this.isAuth === false) {
        this.showAuthConfirm();
        return;
      }
      if (this.caAgreementUrl) {
        this.agreementChecked = true;
        this.goToCaUrl(this.caAgreementUrl);
        return;
      }
      Toast("协议链接获取中，请稍后重试");
    },
    navigateToAuthMobUrl() {
      if (!this.authMobUrl) {
        Toast("认证链接获取中，请稍后重试");
        return;
      }
      const retUrl = encodeURIComponent(window.location.href);
      const separator = this.authMobUrl.indexOf("?") > -1 ? "&" : "?";
      window.location.href = `${this.authMobUrl}${separator}retUrl=${retUrl}`;
    },
    sign() {
      if (this.isAuth === false) {
        this.showAuthConfirm();
        return;
      }
      if (this.hasCaAgreement) {
        this.agreementChecked = true;
        this.goToCaUrl(this.caAgreementUrl);
        return;
      }
      this.$store
        .dispatch("treaty/paymentOnBehalf/signPaymentOnBehalfTreaty", {
          orderId: this.orderId,
          pMoneyRecently: this.pMoneyRecently
        })
        .then(() => {
          const { VUE_APP_SC } = process.env;
          this.isSign = true;
          if (this.returnUrl != null && this.returnUrl != "") {
            window.location.href = this.returnUrl;
            return;
          }
          if (this.pMoneyRecently !== "") {
            // eslint-disable-next-line no-undef
            window.location.href = `${VUE_APP_SC}mob/order/person/toOrderFractionalPayment.do?type=1&orderId=${this.orderId}`;
          }
          // eslint-disable-next-line no-undef
          window.location.href = `${VUE_APP_SC}mob/order/person/orderDetail.do?orderId=${this.orderId}`;
        });
    },
    toBack() {
      if (this.returnUrl != null && this.returnUrl != "") {
        window.location.href = this.returnUrl;
        return;
      }
      const { VUE_APP_SC } = process.env;
      if (this.pMoneyRecently !== "") {
        // eslint-disable-next-line no-undef
        window.location.href = `${VUE_APP_SC}mob/order/person/toOrderFractionalPayment.do?type=1&orderId=${this.orderId}`;
      }
      // eslint-disable-next-line no-undef
      window.location.href = `${VUE_APP_SC}mob/order/person/orderDetail.do?orderId=${this.orderId}`;
    }
  }
};
</script>
